import { apiGet, apiPatch, apiPost } from './client.js';

export type ChecklistType = 'open' | 'close';

export type ChecklistItem = {
  id: string;
  label: string;
  completed: boolean;
  completedAt?: string | null;
  completedBy?: string | null;
  automated?: boolean;
  skipped?: boolean;
  link?: string;
};

export type ChecklistProgress = {
  completed: number;
  total: number;
};

export type StoreChecklist = {
  id: string | null;
  tenantId?: string;
  storeId?: string;
  checklistType: ChecklistType;
  date: string;
  completedBy?: string | null;
  completedAt?: string | null;
  items: ChecklistItem[];
  notes?: string | null;
  createdAt?: string;
  progress: ChecklistProgress;
  /** Present when store has this checklist type disabled for today */
  enabled?: boolean;
};

export type ChecklistItemTemplate = {
  id: string;
  label: string;
  automated?: boolean;
  link?: string;
};

export function getTodayChecklist(type: ChecklistType) {
  return apiGet<StoreChecklist>('/api/v1/checklists/today', { params: { type } }).then((r) => r.data);
}

export function completeChecklistItem(
  checklistId: string,
  itemId: string,
  body?: { skipped?: boolean; notes?: string },
) {
  return apiPost<StoreChecklist, { skipped?: boolean; notes?: string }>(
    `/api/v1/checklists/${checklistId}/items/${itemId}/complete`,
    body,
  ).then((r) => r.data);
}

export function getChecklistHistory(params?: { type?: ChecklistType; days?: number }) {
  return apiGet<StoreChecklist[]>('/api/v1/checklists/history', { params }).then((r) => r.data);
}

export function updateChecklistNotes(checklistId: string, notes: string | null) {
  return apiPatch<StoreChecklist, { notes: string | null }>(`/api/v1/checklists/${checklistId}`, {
    notes,
  }).then((r) => r.data);
}
